import React from 'react';
import { Box, Button, Paper } from '@mui/material';
import { CANtrackComment } from '../../types/comment';
import RichActivityText from '../activityDetails/RichActivityText';
import ActivityTime from '../activityDetails/ActivityTime';
import ActivityGPDA from '../activityDetails/ActivityGPDA';
import useCommentEditor, {
	CommentFormState,
	CommentFormStateErrors,
} from '../../hooks/useCommentEditor';

const CaseCommentEditor: React.FC<{
	comment?: CANtrackComment;
	formState: CommentFormState;
	errors: CommentFormStateErrors;
	handleChange: ReturnType<typeof useCommentEditor>['handleChange'];
	handleSave: ReturnType<typeof useCommentEditor>['handleSaveComment'];
	handleReset: ReturnType<typeof useCommentEditor>['handleResetComment'];
	handleDelete: () => void;
	lockedCase?: boolean;
	hideButtons?: boolean;
}> = ({
	comment,
	formState,
	errors,
	handleChange,
	handleSave,
	handleReset,
	handleDelete,
	lockedCase,
	hideButtons,
}) => {
	return (
		<Paper>
			<Box display={'flex'} flexDirection={'column'} padding={2} gap={1}>
				<ActivityGPDA
					initialComment={comment}
					formState={formState}
					errors={errors}
					handleChange={handleChange}
					lockedCase={lockedCase}
				/>
				<ActivityTime
					formState={formState}
					handleChange={handleChange}
					errors={errors}
				/>
				<RichActivityText
					formState={formState}
					handleChange={handleChange}
					errors={errors}
				/>
				{!hideButtons && (
					<Box
						sx={{
							display: 'flex',
							flexDirection: { xs: 'column', sm: 'row' },
							justifyContent: 'center',
							gap: 2,
						}}
					>
						{comment &&
							comment?.id !== 0 && (
								<Button
									variant="outlined"
									color="error"
									sx={{ width: { xs: '100%', sm: '200px' } }}
									onClick={handleDelete}
								>
									Delete
								</Button>
							)}

						<Button
							variant="contained"
							color="primary"
							onClick={handleSave}
							sx={{ width: { xs: '100%', sm: '200px' } }}
						>
							Save
						</Button>
						<Button
							variant="outlined"
							color="primary"
							onClick={handleReset}
							sx={{ width: { xs: '100%', sm: '200px' } }}
						>
							Reset
						</Button>
					</Box>
				)}
			</Box>
		</Paper>
	);
};

export default CaseCommentEditor;
